import React from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select";

function FilterSelect({ label, value, onChange, options, testId }) {
    return (
        <div className="flex flex-col gap-1.5 min-w-[140px]">
            <label className="text-[10px] tracking-[0.22em] uppercase text-zinc-500 font-manrope font-semibold">
                {label}
            </label>
            <Select value={value} onValueChange={onChange}>
                <SelectTrigger
                    data-testid={testId}
                    className="rounded-none border-white/15 bg-black/40 text-white hover:border-[#FF3B30] focus:border-[#FF3B30] focus:ring-0 font-manrope h-10 uppercase text-xs tracking-wider"
                >
                    <SelectValue />
                </SelectTrigger>
                <SelectContent className="rounded-none bg-[#0f0f0f] border-white/15 text-white font-manrope">
                    {options.map((opt) => (
                        <SelectItem
                            key={opt}
                            value={opt}
                            className="rounded-none uppercase text-xs tracking-wider focus:bg-[#FF3B30]/20 focus:text-white"
                        >
                            {opt}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}

export default function FilterBar({ filters, setFilters, meta }) {
    if (!meta) return null;
    const update = (key) => (value) =>
        setFilters((prev) => ({ ...prev, [key]: value }));

    return (
        <div
            className="flex flex-wrap gap-4 items-end w-full p-4 border border-white/10 bg-white/[0.02] backdrop-blur-md"
            data-testid="filter-bar"
        >
            <FilterSelect
                label="Season"
                value={filters.season}
                onChange={update("season")}
                options={["All", ...meta.seasons]}
                testId="filter-season"
            />
            <FilterSelect
                label="Gender"
                value={filters.gender}
                onChange={update("gender")}
                options={["All", ...meta.genders]}
                testId="filter-gender"
            />
            <FilterSelect
                label="Age Range"
                value={filters.age_range}
                onChange={update("age_range")}
                options={["All", ...meta.age_ranges]}
                testId="filter-age-range"
            />
            <FilterSelect
                label="Event Type"
                value={filters.event_type}
                onChange={update("event_type")}
                options={["All", ...meta.event_types]}
                testId="filter-event-type"
            />
            <button
                onClick={() =>
                    setFilters({
                        season: "All",
                        gender: "All",
                        age_range: "All",
                        event_type: "All",
                    })
                }
                className="h-10 px-5 border border-white/15 hover:border-[#FF3B30] hover:text-[#FF3B30] text-white text-xs uppercase tracking-[0.2em] font-manrope font-semibold transition-colors"
                data-testid="filter-reset"
            >
                Reset
            </button>
        </div>
    );
}
